import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  Dialog as MuiDialog,
  DialogTitle,
  Divider,
  Typography,
  IconButton,
  Stack,
  styled
} from "@mui/material";
import React from "react";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";
import { DIALOG_VARIANTS } from "@hyro-components/Dialogs/DialogConsts";

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: `${theme.spacing(2.25)} ${theme.spacing(3)} ${theme.spacing(2.25)} ${theme.spacing(3)}`,
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.system[200],
  height: "1px",
}));

const AGENT_LAUNCHPAD_PRE_TITLE = "Agent launchpad";
const SUBMIT_BUTTON_TEXT = "Confirm";
const CANCEL_BUTTON_TEXT = "Cancel";

const AgentLaunchpadDialog = ({
  variant = DIALOG_VARIANTS.transactional,
  open,
  title,
  children,
  disableCancel,
  submitButtonText = SUBMIT_BUTTON_TEXT,
  cancelButtonText = CANCEL_BUTTON_TEXT,
  cancelButtonLoading = false,
  handleCancel,
  handleSubmit,
  testId,
  handleClose,
  isLoading = false,
  ...props
}) => (
  <MuiDialog
    {...{
      fullWidth: true,
      open,
      ...props
    }}
    data-testid={testId}
  >
    <Stack direction="column" gap={0.25} padding={3} paddingBottom={0}>
      <Typography variant="subtitle2" color="text.700">{ isLoading || variant === DIALOG_VARIANTS.acknowledgement ? "" : AGENT_LAUNCHPAD_PRE_TITLE}</Typography>
      <DialogTitle component="h6" sx={{ padding: 0 }} data-testid={`${testId}-dialog-title`}>{ isLoading ? "" : title}</DialogTitle>
    </Stack>
    <DialogContent>{children}</DialogContent>
    <IconButton
      data-testid={`${testId}-close-icon`}
      onClick={handleClose}
      aria-label="close"
      sx={{ position: "absolute", right: 24, top: 24, padding: 0, width: "24px", height: "24px" }}
    >
      <CloseIcon sx={{ fontSize: "20px" }} />
    </IconButton>
    {!isLoading && variant === DIALOG_VARIANTS.transactional && <StyledDivider orientation="horizontal" />}
    <StyledDialogActions>
      {variant === DIALOG_VARIANTS.transactional && !isLoading ? (
        <HyroButton
          disabled={disableCancel}
          loading={cancelButtonLoading}
          variant={BUTTON_VARIANTS.TEXT}
          color={BUTTON_COLORS.SECONDARY}
          onClick={handleCancel}
          data-testid={`${testId}-cancel-button`}
        >
          {cancelButtonText}
        </HyroButton>
      ) : null}
      {!isLoading && <HyroButton
        {...{
          loading: false,
          color: BUTTON_COLORS.PRIMARY,
          variant: BUTTON_VARIANTS.CONTAINED,
          onClick: handleSubmit
        }}
        data-testid={`${testId}-submit-button`}
      >
        {submitButtonText}
      </HyroButton>}
    </StyledDialogActions>
  </MuiDialog>
);

export default AgentLaunchpadDialog;
